import styled from '@emotion/styled'

const NowrapDiv = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  ${({ $lines }) =>
    !!$lines && $lines > 1
      ? 'display: -webkit-box;' +
        `-webkit-line-clamp: ${$lines};` +
        '-webkit-box-orient: vertical;'
      : 'white-space: nowrap;'};
  line-height: ${({ $fixHeight }) => ($fixHeight ? '1.2em' : '')};
  height: ${({ $lines, $fixHeight }) =>
    $fixHeight ? ($lines || 1) * 1.2 + 'em' : 'auto'};
  text-align: ${({ $textCenter }) => ($textCenter ? 'center' : 'left')};
`

export default NowrapDiv
